/** Friendly German labels for content keys shown in the editor. */
export const SECTION_LABELS: Record<string, string> = {
  nav: 'Navigation (Menü)',
  hero: 'Startbereich',
  about: 'Über mich',
  treatments: 'Behandlungen – Übersicht',
  mesoporation: 'Mesoporation',
  philosophy: 'Meine Philosophie',
  services: 'Leistungen & Preise',
  studio: 'Studio / Atmosphäre',
  contact: 'Kontakt',
  footer: 'Fußzeile',
};

const FIELD_LABELS: Record<string, string> = {
  brand: 'Markenname',
  name: 'Name',
  title: 'Überschrift',
  eyebrow: 'Kleine Überschrift',
  subtitle: 'Untertitel',
  intro: 'Einleitung',
  intro1: 'Einleitung (1. Absatz)',
  intro2: 'Einleitung (2. Absatz)',
  desc: 'Beschreibung',
  price: 'Preis',
  priceOld: 'Alter Preis',
  priceNew: 'Neuer Preis',
  note: 'Hinweis',
  badge: 'Auszeichnung / Banner',
  text: 'Text',
  text1: 'Text (1. Absatz)',
  text2: 'Text (2. Absatz)',
  text3: 'Text (3. Absatz)',
  text4: 'Text (4. Absatz)',
  p1: 'Absatz 1',
  p2: 'Absatz 2',
  p3: 'Absatz 3',
  p4: 'Absatz 4',
  tags: 'Schlagworte',
  caption: 'Bildunterschrift',
  caption1: 'Bildunterschrift 1',
  caption2: 'Bildunterschrift 2',
  caption3: 'Bildunterschrift 3',
  email: 'E-Mail-Adresse',
  phone: 'Telefonnummer',
  address: 'Adresse',
  scroll: 'Scroll-Hinweis',
  copyright: 'Copyright-Zeile',
  resultsTitle: 'Überschrift Ergebnisliste',
  results: 'Behandlungsergebnisse',
  boxLabel: 'Beschriftung Kontaktbox',
  shareLabel: 'Beschriftung „Teilen“',
  ctaText: 'Aufruf-Text',
  ctaButton: 'Button-Beschriftung',
  groupFace: 'Gruppentitel: Gesicht',
  groupSpecial: 'Gruppentitel: Spezial',
  groupEyes: 'Gruppentitel: Augen',
  face: 'Gesichtsbehandlungen',
  special: 'Spezialbehandlungen',
  eyes: 'Augenblicke',
  meso: 'Mesoporation-Angebot',
  cards: 'Karten',
  block1: 'Block 1: Gesichtsbehandlungen',
  block2: 'Block 2: Spezialbehandlungen',
  block3: 'Block 3: Schöne Augen',
  linkAbout: 'Menüpunkt „Über mich“',
  linkBehandlungen: 'Menüpunkt „Behandlungen“',
  linkMesoporation: 'Menüpunkt „Mesoporation“',
  linkLeistungen: 'Menüpunkt „Leistungen“',
  linkKontakt: 'Menüpunkt „Kontakt“',
};

export function labelFor(key: string): string {
  if (FIELD_LABELS[key]) return FIELD_LABELS[key];
  if (SECTION_LABELS[key]) return SECTION_LABELS[key];
  // Fallback: humanize the key.
  return key.charAt(0).toUpperCase() + key.slice(1);
}
